import $ from 'jquery';
import _ from 'underscore';
import MappingBase from "./MappingBase";
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';

let infoWindowTemplate = require("../../hbs-templates/infoWindow.handlebars");
let locationsListTemplate = require("../../hbs-templates/locationsList.handlebars");
let mapLocationsListTemplate = require("../../hbs-templates/mapLocationsList.handlebars");

/**
 * @file LocationMap.js
 */
class LocationsMap extends MappingBase {
  constructor() {
    super();

    // Set defaults;
    this.allMarkers = [];
    this.allInfoWindows = [];
    this.allLocations = [];
    this.focusLat = null;
    this.focusLng = null;
    this.visitorLat = null;
    this.visitorLng = null;
    this.closestLocationId = null;
    this.closestLocations = [];

    // Get data
    this.getData();
  }

  /**
   * The latitude the map is currently focused on
   *
   * @type float
   */
  focusLat() {
    get; set;
  }

  /**
   * The longitude the map is currently focused on
   *
   * @type float
   */
  focusLng() {
    get; set;
  }

  /**
   * The current visitors latitude
   *
   * @type float
   */
  visitorLat() {
    get; set;
  }

  /**
   * The current visitors longitude
   *
   * @type float
   */
  visitorLng() {
    get; set;
  }

  /**
   * The ID of the closest location
   *
   * @type integer
   */
  closestLocationId() {
    get; set;
  }

  /**
   * An array of the closest locations to the
   * visitor sorted by distance
   *
   * @type Array<Object>
   */
  closestLocations() {
    get; set;
  }

  /**
   * Retrieves the locations from the backend
   */
  getData() {
    // Load session data
    this.getPersistedData();

    // Bind search interface
    let ref = this;
    $('#locationsSearch').on('keypress', function(event) {
      if (event.keyCode === 13) {
        ref.searchLocations();
      }
    });

    $('#locationsSearchButton').on('click', function(event){
      ref.searchLocations();
    });

    // Load locations
    fetch(window.location.origin + '/api/locations',
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      }).then((response) => {
      if (response.ok) {
        response.json().then((r) => {
          this.allLocations = r;

          // Check if we already have a location set
          if (this.closestLocationId) {
            let _id = this.closestLocationId;
            let closestLocation = MappingBase.getLocationById(_id, this.allLocations);

            if (closestLocation) {
              this.focusLat = parseFloat(closestLocation.Lat);
              this.focusLng = parseFloat(closestLocation.Lng);
            }

            // Load map
            this.loadMap();

            let listLocations = [];
            for (let i = 0; i < this.closestLocations.length; i++) {
              let _loc = MappingBase.getLocationById(this.closestLocations[i].LocationId, this.allLocations);
              if (_loc) {
                _loc.Distance = this.closestLocations[i].Distance;
                listLocations.push(_loc);
              }
            }

            // Load locations list
            this.loadMapList(listLocations);
          } else {
            // Locate the visitor
            this.getVisitorLocation();
          }

          // Load list view
          this.loadListView(this.allLocations);
        });
      }
      else {
        console.log('Error getting data');
      }
    });
  };

  /**
   * Retrieves the current visitors location based on geolocation
   */
  getVisitorLocation() {
    if (navigator.geolocation) {
      let ref = this;
      navigator.geolocation.getCurrentPosition(function(position) {
        ref.visitorLat = position.coords.latitude;
        ref.visitorLng = position.coords.longitude;

        ref.loadMap();
        ref.getClosestLocation();
      },
      function(error) {
        ref.loadMap();
      },
      {
        enableHighAccuracy: true
      });
    }
  };

  /**
   * Renders the map
   */
  async loadMap() {
    setOptions({
      key: drupalSettings.loomis_maps.api_key,
      v: 'weekly',
      libraries: ["geometry"]
    });

    const { Map } = (await importLibrary('maps'));
    let mapOptions = {};
    if (this.focusLat && this.focusLng) {
      mapOptions = {
        zoom: 10,
        center: new google.maps.LatLng(this.focusLat, this.focusLng),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        minZoom: 4,
        mapId: 'Locations_Map'
      };
    } else {
      mapOptions = {
        zoom: 4,
        center: new google.maps.LatLng(39.8282, -98.5795),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        minZoom: 4,
        mapId: 'Locations_Map'
      };
    }

    this.map = new Map(document.getElementById('locations'), mapOptions);

    if (this.allLocations) {
      for (let i = 0; i < this.allLocations.length; i++) {
        await this.createMarker(this.map, this.allLocations[i]);
      }
    }
  }

  /**
   * Renders the map list of locations
   *
   * @param locations
   */
  loadMapList(locations) {
    // Closest location should be set, but check just to be safe
    if (this.closestLocationId !== null) {

      for (let i = 0; i < locations.length; i++) {
        locations[i].Number = i + 1;
        locations[i].IsClosest = parseInt(locations[i].Nid) === parseInt(this.closestLocationId);
      }

      // Update UI
      $('div.locations-list-container').html(
        mapLocationsListTemplate({ 'Locations': locations })
      ).addClass('open');

      $('.col--locations-nearest').removeClass('hidden'); // reveal locations sidebar

      let ref = this;
      $('[data-bind="jumpToLocation"]').each(function(i, item) {
        $(item).off('click');
        $(item).on('click', function() {
          ref.jumpToLocation($(item).data('args'));
        });
      });
    }
  };

  /**
   * Renders the full locations list
   *
   * @param locations
   */
  loadListView(locations) {
    // Sort locations first
    locations.sort(function(a, b) {
      let nameA = a.Title.toLowerCase(), nameB = b.Title.toLowerCase();
      if (nameA < nameB)
        return -1;
      if (nameA > nameB)
        return 1;
      return 0;
    }).sort(function(a, b) {
      let nameA = a.StateFull.toLowerCase(), nameB = b.StateFull.toLowerCase();
      if (nameA < nameB)
        return -1;
      if (nameA > nameB)
        return 1;
      return 0;
    });

    // Group by state
    let locationsGrouped = _.groupBy(locations, function(g) {
      return g.StateFull;
    });

    // Build markup
    $('#locations-all-container').append(
      locationsListTemplate({
        'Locations': locationsGrouped
      })
    );
  };

  /**
   * Performs keyword-based search
   */
  searchLocations() {
    let searchInput = $('#locationsSearch').val();
    if (searchInput.trim() !== '') {

      // switch to 'Map View' if it's not already active
      if ($('#list-view-tab').hasClass('active')) {
        $('.map-toggle-container #map-view-tab').trigger('click');
      }
      this.getClosestLocation(searchInput);
    }
  };

  /**
   * Creates markers and adds them to the map
   *
   * @param map
   * @param location
   */
  async createMarker(map, location) {
    let latLng = new google.maps.LatLng(
      parseFloat(location.Lat),
      parseFloat(location.Lng)
    );

    // Create the AdvancedMarkerElement container
    const container = document.createElement("div");
    container.className = "marker-container";

    // Populate location data
    container.innerHTML = infoWindowTemplate(location);

    // Wire up close button
    const closeBtn = container.querySelector(".close-btn");
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      container.classList.remove("is-expanded");
    });

    // Wire up open button
    container.addEventListener("click", () => {
      this.openMarkerById(location.Nid);
    });

    // Now actually create the marker and add to the map
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: latLng,
      content: container,
      gmpClickable: true
    });

    // Add to collection
    this.allMarkers[location.Nid] = marker;

    // If closest location is set, open the info window
    if (this.closestLocationId) {
      if (this.closestLocationId === parseInt(location.Nid)) {
        this.openMarkerById(location.Nid);
      }
    }
  };

  /**
   * Opens a saved marker by Node ID
   *
   * @param Nid
   */
  openMarkerById(Nid) {
    const targetMarker = this.allMarkers[Nid];
    this.allMarkers.forEach((marker) => {
      marker.content.classList.remove('is-expanded');
      marker.zIndex = 0;
    });

    targetMarker.content.classList.add('is-expanded');
    targetMarker.zIndex = 9999;
    this.map.panTo(targetMarker.position);
  };

  /**
   * Geocodes a supplied string or uses the visitor's location
   *
   * @param input
   */
  getClosestLocation(input) {
    let _origin;
    let _ref = this;
    if (input) {
      // Geocode input
      let geocoder = new google.maps.Geocoder();
      geocoder.geocode({ 'address': input }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          _origin = results[0].geometry.location;
          _ref.getClosestLocationCallback(_origin);
        }
      });
    } else {
      // Use GPS data
      if (this.visitorLat && this.visitorLng) {
        _origin = new google.maps.LatLng(this.visitorLat, this.visitorLng);
        _ref.getClosestLocationCallback(_origin);
      } else {
        _origin = new google.maps.LatLng(0, 0);
        _ref.getClosestLocationCallback(_origin);
      }
    }
  };

  /**
   * Handles UI updates after getting the visitor's location
   *
   * @param response
   */
  getClosestLocationCallback(response) {
    let locationDistances = [];
    for (let i = 0; i < this.allLocations.length; i++) {
      let _latLng = new google.maps.LatLng(
        parseFloat(this.allLocations[i].Lat),
        parseFloat(this.allLocations[i].Lng)
      );

      let dist = google.maps.geometry.spherical.computeDistanceBetween(response, _latLng);
      let distanceMi = LocationsMap.convertMetersToMiles(dist);
      locationDistances.push({
        "LocationId": this.allLocations[i].Nid,
        "Distance": Math.round(distanceMi)
      });
    }

    if (locationDistances.length > 0) {
      // Sort by distance
      let locationsTemp = locationDistances;
      locationsTemp.sort(LocationsMap.compareByDistance);

      // Update variables
      this.closestLocationId = locationsTemp[0].LocationId;
      this.closestLocations = locationsTemp.slice(0, 10);

      // Update persisted data
      this.setPersistedData(this.closestLocationId, this.closestLocations);

      let listLocations = [];
      for (let i = 0; i < this.closestLocations.length; i++) {
        let _loc = MappingBase.getLocationById(this.closestLocations[i].LocationId, this.allLocations);
        _loc.Distance = this.closestLocations[i].Distance;
        listLocations.push(_loc);
      }

      // Load locations list
      this.loadMapList(listLocations);

      // Refocus map
      let closestLocation = MappingBase.getLocationById(this.closestLocationId, this.allLocations);
      if (closestLocation) {
        this.map.setCenter({ lat: parseFloat(closestLocation.Lat), lng: parseFloat(closestLocation.Lng) });
        this.map.setZoom(10);
        this.openMarkerById(closestLocation.Nid);
      }
    }
  };

  /**
   * Retrieves session data
   */
  getPersistedData() {
    let locationId = window.sessionStorage.getItem('Loomis_ClosestLocation');
    if (locationId) {
      this.closestLocationId = parseInt(locationId);
    }
    let locationsSorted = window.sessionStorage.getItem('Loomis_SortedLocations');
    if (locationsSorted) {
      this.closestLocations = JSON.parse(locationsSorted);
    }
  };

  /**
   * Sets persisted data
   * @param _closetLocationId
   * @param _locationsSorted
   */
  setPersistedData(_closetLocationId, _locationsSorted) {
    if (_closetLocationId) {
      window.sessionStorage.setItem('Loomis_ClosestLocation', _closetLocationId);
    }
    if (_locationsSorted) {
      window.sessionStorage.setItem('Loomis_SortedLocations', JSON.stringify(_locationsSorted));
    }
  };

  /**
   * Moves map to selected location ID
   *
   * @param locationId
   */
  jumpToLocation(locationId) {
    let location = MappingBase.getLocationById(locationId, this.allLocations);
    if (location) {
      this.map.setCenter({ lat: parseFloat(location.Lat), lng: parseFloat(location.Lng) });
      this.map.setZoom(10);
      this.openMarkerById(locationId);
    }
  };

}

// Load map once we confirm we have the API key
if (drupalSettings.loomis_maps.api_key) {
  var map = new LocationsMap();
}

/**
 * State filtering functionality
 */
(function($){
  let $statesFilter = $('.locations-alpha-filter .js-selectpicker-states-filter');
  $statesFilter.selectpicker({
    size: 6,
  });
  // Link bootstrap-select state filters to matching content
  function attachFilterListeners() {
    $('.locations-alpha-filter select').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
      // scroll to State section
      $('html, body').animate({
        scrollTop: $(e.target.value).offset().top - 100, // 100px to offset sticky nav
      }, 800);
    });
  }
  attachFilterListeners();
})(jQuery);

